import LoadingFullScreen from './LoadingFullScreen';

export default LoadingFullScreen;
